import { firstValueFrom } from 'rxjs'
import { trackLaunchNetworkEvent } from '@wf-mfe/logger'
import { getTreatmentIsEnabled } from '@wf-mfe/toggles'
import { GET, POST } from './constants.js'

export function getInitialTrackingObject(fetchOptions) {
  return {
    method:
      fetchOptions.method || (fetchOptions.body === undefined ? GET : POST),
  }
}

export async function trackRequest(url, tracking) {
  const useLogger = await firstValueFrom(
    getTreatmentIsEnabled('track-network-requests-using-logger')
  )

  if (useLogger) {
    return trackLaunchNetworkEvent(url, tracking.method)
  } else {
    if (window._satellite) {
      window._satellite.track('network_request', {
        request: url,
        method: tracking.method,
      })
    }
  }
}
